/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ImportProtocolStatus {
    Processing = '0',
    Successful = 1,
    Failed = 2,
}
